import Api from './api';
import { PRIVILEGES_URL } from '../constants/urls';

export const getPrivilegesRequest = (params) => Api(
  { url: PRIVILEGES_URL, params },
  { isEntityAttributes: true },
);
